import React from "react";
import { useEffect, useState } from "react";
import { FormControl, InputLabel, TextField } from "@material-ui/core";
import { ApiBackend } from "../../providers/apibackend";
import { Autocomplete } from "@material-ui/lab";


type Props = {
    initialValue?: string;
    label?: string;
    style?: React.CSSProperties
    onChange: (value: string) => void;
};

const CodeHolderCodeOwnerPicker = (props: Props) => {
    const [value, setValue] = useState<string>(props.initialValue ?? "");
    const [inputValue, setInputValue] = useState<string>(props.initialValue ?? "");
    const [data, setData] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);

    const api = new ApiBackend();

    useEffect(() => {
        fetchData();
    }, []);

    const render = () => {
        const { label } = props;

        if (loading) {
            return (
                <TextField id="codeowner-select-text"
                    style={{ flex: 1, margin: '0 3px' }}
                    value={inputValue}
                    label={label ? label : "Kodägare"}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                />
            );
        }

        return (
            <FormControl fullWidth>
                <InputLabel shrink htmlFor="codeowner-select">{label ? label : "Kodägare"}</InputLabel>
                <Autocomplete id="codeowner-select"
                    style={{ marginTop: 12 }}
                    defaultValue={value}
                    inputValue={inputValue}
                    onChange={handleChange}
                    onInputChange={handleInputChange}
                    freeSolo={true}
                    multiple={false}
                    openOnFocus
                    options={data}
                    renderInput={(params) => (
                        <TextField {...params} value={value} />
                    )}
                />
            </FormControl>
        );
    };

    const handleChange = (evt: React.ChangeEvent, nextValue: string) => {
        setValue(nextValue);
        notifyChange(nextValue);
    };

    const handleInputChange = (evt: React.ChangeEvent, nextValue: string) => {
        setInputValue(nextValue);
        notifyChange(nextValue);
    };

    const notifyChange = (nextValue: string) => {
        const { onChange } = props;
        onChange(nextValue);
    };

    const fetchData = async () => {
        const res = await api.listCodeHolderCodeOwners();

        setData(res);
        setLoading(false);
    };

    return render();
};

export default CodeHolderCodeOwnerPicker;
